import React, { useState, useEffect, useRef } from "react";
import Typed from "typed.js";
import Header from "../Components/Header";
import Sidebar from "../Components/Sidebar";
import Footer from "../Components/Footer";
import RouteApi from "../Backend/Backend";
import { useSelector } from "react-redux";
import { useParams, useNavigate, Link } from "react-router-dom";
import confetti from "canvas-confetti";
import Swal from "sweetalert2";
import { isMobile } from "react-device-detect";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const Exercise = () => {
    const navigate = useNavigate();
    const { id } = useParams(); // Retrieve the dynamic id from the route params
    const { handleExerciseSubmit, getSubjects, getExerciseList, deleteExerciseByToken } = RouteApi();

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ align: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ color: [] }, { background: [] }],
            [{ script: "sub" }, { script: "super" }], // Added line for sub/super
            ["blockquote", "code-block"],
            ["link", "image", "video"],
            ["clean"],
        ],
    };

    const formats = [
        "header", "bold", "italic", "underline", "strike",
        "align", "list", "bullet",
        "color", "background",
        "script", // Added "script" format
        "blockquote", "code-block",
        "link", "image", "video"
    ];

    const [trigger, setTrigger] = useState(null);
    const [message, setMessage] = useState("");
    const [required, setRequired] = useState("");


    const typedElement = useRef(null);
    const typedInstance = useRef(null);

    const [search, setSearch] = useState(""); // 🔍 Search State


    useEffect(() => {
        if (required) {
            typedInstance.current = new Typed(typedElement.current, {
                strings: [

                    trigger === "Description"
                        ? required
                        : trigger === "exercise_name_exists"
                            ? required + "- Exercise name already exists. Please choose a different name."
                            : trigger === "Ai_Response"
                                ? required + "- Exercise name already exists. Please choose a different name."
                                : trigger

                ],
                typeSpeed: 40,
                backSpeed: 25,
                backDelay: 3000,
                startDelay: 500,
                loop: false,
                smartBackspace: true,
                showCursor: true,
                cursorChar: "|"
            });
        }

        return () => {
            typedInstance.current?.destroy();
            typedInstance.current = null;
        };
    }, [required]);

    const user = useSelector((state) => state.auth?.user);

    // Get user details
    const fname = user?.ghostuser || ""; // Default to empty if not available
    const email = user?.email || "";
    const phone = user?.phone || "";

    useEffect(() => {
        confetti({
            particleCount: 500,
            spread: 100,
            origin: { y: 0.6 },
            colors: ["#ffffff", "#d291bc", "#957dad"],
        });
    }, []);

    const [ExerciseList, setExerciseList] = useState([]);

    const loadExerciseList = async () => {
        const ExerciseData = await getExerciseList();
        console.log("Exercise Data:", ExerciseData);

        const { success, tasks } = ExerciseData;

        if (success && Array.isArray(tasks)) {
            setExerciseList(tasks);
        } else {
            setExerciseList([]);
        }
    };

    useEffect(() => {
        loadExerciseList(); // initial load
    }, []);

    const [ExerciseData, setExerciseData] = useState({
        name: "",
        type: "",
        subject: "",
        studentClass: "",
        duration: "",
        accessPassword: "",
        description: "Set [number] [subject] questions for [class] [time number] minutes, [easy, medium, hard] difficulty. Nigeria Scheme. Week [number] Topic.",
        lenient: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setExerciseData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const [isSubmitting, setIsSubmitting] = useState(false);

    const submitExercise = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await handleExerciseSubmit(ExerciseData);
            if (response.success) {
                toast.success("Exercise created successfully!", { /* toast config */ });

                const refreshed = await getExerciseList();
                if (refreshed.success && Array.isArray(refreshed.Exercises)) {
                    setExerciseList(refreshed.Exercises);
                }

                setTimeout(() => {
                    navigate("./create", {
                        state: {
                            trigger: response.trigger,
                            required: response.required,
                            message: response.message,
                            exerciseId: response.token,
                        },
                    });
                }, 2000);
            } else {
                setTrigger(response.trigger || null);
                setMessage(response.message || "An error occurred.");
                setRequired(response.required || "Please fill all required fields.");
            }
        } catch (err) {
            Swal.fire({
                text: "An error occurred while creating Exercise.",
                icon: "error",
                confirmButtonText: "Ok, got it!",
                customClass: { confirmButton: "btn fw-bold btn-danger" },
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const [subjects, setSubjects] = useState([]);

    useEffect(() => {
        // dynamically set this as needed
        getSubjects(id, setSubjects);
        //setTrigger('Description');
        localStorage.setItem("lastSelectedExerciseColumnId", 1);
    }, []);

    const handleDeleteExercise = async (tokenId) => {
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "You are about to delete this Exercise permanently.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#40196d",
          cancelButtonColor: "#dc2626",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel",
        });
      
        if (!result.isConfirmed) return;
      
        const res = await deleteExerciseByToken(tokenId);
      
        if (res.success) {
          toast.success("✅ Exercise deleted successfully");
          loadExerciseList();
        } else {
          toast.error("❌ Failed to delete Exercise");
        }
      };

    return (
        <div className="bg-back">
            <Header />
            <Sidebar />

            <div className="docs-wrapper bg-back">

                <div className="container-fluid pt-lg-12 pt-14 pb-12 pb-lg-12">
                    <div className="px-2 px-lg-4">
                        <div className="row gx-6 gy-6">
                            <div className="col-12">
                                <div className="d-lg-flex align-items-center">
                                    <div className="col fs-t text-q2 fw-medium mb-lg-0 mb-4">
                                        <i className="bi bi-stars text-warning"></i>
                                        <span className="ms-2">Get Exercise Ready In Secs.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid px-2 px-lg-12 pt-lg-12 pt-6 pb-10 pb-lg-10 mt-lg-n18 mt-n12">
                    
                    <div
                        className="card bg-white shadow-none"
                        style={{ borderRadius: "18px" }}
                    >
                        <div className="row gx-6 gy-4 align-items-center px-lg-6 px-4 py-4">
                            <div className="d-flex align-items-center mb-2 mb-lg-1">
                                <div className="col">
                                    <div className="fs-10 text-q2 fw-medium">
                                        <span className="">Workspace</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 px-lg-8">
                                <div className="">
                                    <div className="text-dark fs-3 fw-medium mb-3">
                                        <i className="bi bi-plus-lg "></i> Create Exercise
                                    </div>
                                </div>

                                <div className="row gx-6 gy-4 align-items-center justify-content-between">
                                    <form className="col-12 col-lg-12" onSubmit={submitExercise}>
                                        <div className="row gx-3 gy-4 mb-6 mb-lg-4">
                                            <div className="col-12 col-lg-6 mb-2 mb-lg-0">
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        id="name-input"
                                                        value={ExerciseData.name}
                                                        onChange={handleChange}
                                                        placeholder="Exercise Name ID"
                                                        required
                                                        className="form-control form-control-lg rounded-4 bg-back text-dark text-uppercaes"
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12 col-lg-3 mb-2 mb-lg-0">
                                                <div className="form-group">
                                                    <select
                                                        name="type"
                                                        value={ExerciseData.type}
                                                        onChange={handleChange}
                                                        required
                                                        className="form-select form-select-lg rounded-4 bg-back text-dark"
                                                    >
                                                        <option value="">Select Exercise Type</option>
                                                        <option value="Classwork">Classwork</option>
                                                        <option value="Homework">Homework</option>
                                                    </select>
                                                </div>
                                            </div>


                                            <div className="col-12 col-lg-3 mb-2 mb-lg-0">
                                                <div className="form-group">
                                                    <select
                                                        name="studentClass"
                                                        value={ExerciseData.studentClass}
                                                        onChange={handleChange}
                                                        className="form-select form-select-lg rounded-4 bg-back text-dark"
                                                        required
                                                    >
                                                        <option value="">Select Class</option>
                                                        {[
                                                            "Preparatory 1",
                                                            "Preparatory 2",
                                                            "Reception 1",
                                                            "Reception 2",
                                                            "PlayGroup",
                                                            "NUR 1",
                                                            "NUR 2",
                                                            "KG 1",
                                                            "KG 2",
                                                            "Grade 1",
                                                            "Grade 2",
                                                            "Grade 3",
                                                            "Grade 4",
                                                            "Grade 5",
                                                            "Grade 6",
                                                            "Jss1",
                                                            "Jss2",
                                                            "Jss3",
                                                            "sss1",
                                                            "sss2",
                                                            "sss3",
                                                        ].map((cls) => (
                                                            <option key={cls} value={cls}>
                                                                {cls}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-12 col-lg-4 mb-2 mb-lg-0">
                                                <div className="form-group">
                                                    <select
                                                        name="subject"
                                                        value={ExerciseData.subject}
                                                        onChange={handleChange}
                                                        required
                                                        className="form-select form-select-lg rounded-4 bg-back text-dark"
                                                    >
                                                        <option value="">Select Subject</option>
                                                        {subjects.map((subject, index) => (
                                                            <option key={index} value={subject}>
                                                                {subject}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-12 col-lg-4 mb-2 mb-lg-0">
                                                <div className="form-group">
                                                    <input
                                                        type="number"
                                                        name="duration"
                                                        value={ExerciseData.duration}
                                                        onChange={handleChange}
                                                        className="form-control form-control-lg rounded-4 bg-back text-dark"
                                                        placeholder="Duration (minutes)"
                                                        min="1"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12 col-lg-4 mb-2 mb-lg-0">
                                                <div className="form-group">
                                                    <select
                                                        name="lenient"
                                                        value={ExerciseData.lenient}
                                                        onChange={handleChange}
                                                        required
                                                        className="form-select form-select-lg rounded-4 bg-back text-dark"
                                                    >
                                                        <option value="">Select Mark Leniency</option>
                                                        <option value="Easy">Easy</option>
                                                        <option value="Medium">Medium</option>
                                                        <option value="Hard">Hard</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-12 mb-5 mb-lg-0">
                                                <div className="form-group">
                                                    <ReactQuill
                                                        theme="snow"
                                                        value={ExerciseData.description}
                                                        onChange={(value) =>
                                                            setExerciseData((prev) => ({ ...prev, description: value }))
                                                        }
                                                        modules={modules}
                                                        formats={formats}
                                                        placeholder="Optional description for AI to generate questions"
                                                        className="form-control form-control-lg rounded-4 bg-back text-dark quill-no-border"
                                                        style={{ height: "200px" }} // 👈 increase height here
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                        <div>
                                            <button
                                                className="btn btn-dark btn-lg rounded-4 px-5 mt-4 d-flex align-items-center justify-content-center gap-2"
                                                type="submit"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm text-warning" role="status" aria-hidden="true"></span>
                                                        <span>Generating...</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="bi bi-stars text-warning"></i> Create Exercise
                                                    </>
                                                )}
                                            </button>
                                        </div>

                                    </form>

                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                <div className="container-fluid px-2 px-lg-8 pt-lg-16 pt-8 pb-10 pb-lg-10 mt-lg-n16 mt-n12">
                    
                    <div
                        className="card bg-white shadow-none"
                        style={{ borderRadius: "18px" }}
                    >
                        <div className="row gx-6 gy-4 align-items-center px-lg-2 px-4 py-4">

                            <div className="col-12 px-lg-8 mt-lg-0">
                                <div className="mt-5 bg-white shadow-none">
                                    <div className="shadow-none border-0 py-0 mt-4">
                                        <span className="fs-10">
                                            <i class="bi bi-card-checklist text-dark"></i>{" "}
                                            <span className="fs-10 text-q2 fw-medium">Exercise Lists</span>
                                        </span>
                                    </div>

                                    {/* 🔹 Search Input */}
                                    <div className="row mt-6 mt-lg-6">

                                        <div className="col-lg-8 position-relative">
                                            <input
                                                className="form-control form-control-md text-dark fs-4 rounded-pill ps-8"
                                                placeholder="Search with references"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                style={{ paddingLeft: "2.5rem" }} // Ensure padding for icon space
                                            />
                                            <i
                                                className="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-5 text-muted"
                                                style={{ fontSize: "1.5rem" }}
                                            ></i>
                                        </div>

                                    </div>

                                    <div className="py-0 mt-8 mb-6 px-2 py-lg-0 mt-lg-8 mb-lg-6 px-lg-4">
                                        <div className="table-responsive table-card"
                                            style={{
                                                borderRadius: "10px",
                                                scrollbarWidth: "thin",
                                            }}>

                                            <table
                                                className="table table-hover table-border table-centered table-nowrap table-align-middle mb-0"
                                                style={{ fontSize: "1rem" }}
                                            >
                                                <thead className="">
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Title</th>
                                                        <th>Class</th>
                                                        <th>Type</th>
                                                        <th>Time</th>
                                                        <th>Status</th>
                                                        <th>Leniency</th>
                                                        <th>Action</th>
                                                        <th></th>
                                                        <th>Date</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ExerciseList && ExerciseList.length > 0 ? (
                                                        ExerciseList.map((item, index) => (
                                                            <tr key={item.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.title || "Untitled"}</td>
                                                                <td>{item.cbt_class}</td>
                                                                <td>{item.task_type}</td>
                                                                <td>{item.timer} Mins</td>
                                                                <td>
                                                                    <span
                                                                        className={`badge ${item.dispatch === "1"
                                                                            ? "bg-success"
                                                                            : "bg-secondary"
                                                                            }`}
                                                                    >
                                                                        {item.dispatch === "1" ? "Active" : "Draft"}
                                                                    </span>
                                                                </td>
                                                                <td>{item.favorite}</td>
                                                                
                                                                <td>
                                                                <button
                                                                    className="btn btn-sm btn-purple text-white rounded-3"
                                                                    onClick={() =>
                                                                    navigate("./create", {
                                                                        state: {
                                                                        trigger: null,
                                                                        required: null,
                                                                        message: null,
                                                                        exerciseId: item.token_id,
                                                                        },
                                                                    })
                                                                    }
                                                                >
                                                                    View
                                                                </button>
                                                                </td>


                                                                <td></td>

                                                                <td>{new Date(item.trn_date).toLocaleString()}</td>

                                                                <td><div className="btn btn-sm btn-danger rounded-3" onDoubleClick={() => handleDeleteExercise(item.token_id)}>
                                                                  <i className="bi bi-trash fs-4 text-white"></i>
                                                                </div></td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="11" className="text-center text-muted py-4">
                                                                No exercises available.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    {(trigger === "Description" || trigger === "exercise_name_exists" || trigger === "Ai_Response") && (
                        <div
                            className={`offcanvas offcanvas-bottom show popup-fade-in bg-purple shadow`}
                            data-bs-scroll="true"
                            data-bs-backdrop="false"
                            tabIndex="-1"
                            id="run_task"
                            aria-labelledby="offcanvasBottomLabel"
                            style={
                                isMobile
                                    ? {}
                                    : {
                                        borderRadius: "20px",
                                        width: "350px",
                                        height: "300px",
                                        bottom: "90px",
                                        left: "auto",
                                        right: "5px",
                                        border: "none",
                                        boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
                                    }
                            }
                        >
                            <div className="offcanvas-header">
                                <div className="fs-3 text-white fw-medium" id="offcanvasBottomLabel">
                                    <i className="bi bi-stars text-warning fs-t1"></i> Smart Ai Desk
                                </div>
                                <button
                                    className="btn btn-white btn-icon rounded-br-lg2 rounded-bl-sm2 rounded-t-lg2"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                    onClick={() => setTrigger(null)}
                                >
                                    <i className="bi bi-x-lg fw-bold fs-3 text-dark"></i>
                                </button>
                            </div>
                            <div className="offcanvas-body small py-0 px-lg-7">
                                {trigger && (
                                    <div className="mt-2">
                                        <div className="fs-medium text-danger fs-3 mb-2">Error - {trigger}</div>
                                        {required && (
                                            <span className="text-white fs-4 mt-2 d-block">
                                                <span ref={typedElement}></span>
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    <Footer />

                </div>
            </div>
        </div>
    );
};

export default Exercise;
